import PropTypes from "prop-types";

export default function TextError({ errors }) {
  return <p className="text-red-600 text-sm mt-2 ml-2">{errors}</p>;
}

TextError.propTypes = {
  errors: PropTypes.string.isRequired,
};
